module.exports = __webpack_public_path__ + "media/images/background/no_imagen_400-8d87929b0a7d4ed0c54d942df64cac4a.jpg";